(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mawjood-catalog-ui"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.mawjoodCatalogReady) return;
  window.mawjoodCatalogReady = true;
  const focusOrigins = new WeakMap();
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const scrollButton = target.closest('[data-mw-recommendation-scroll]');
    if (scrollButton) {
      const track = document.getElementById(scrollButton.getAttribute('aria-controls'));
      if (track) {
        const card = track.firstElementChild;
        const distance = (card?.getBoundingClientRect().width || 148) + (parseFloat(getComputedStyle(track).gap) || 12);
        const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
        track.scrollBy({left:distance * direction * Number(scrollButton.dataset.mwRecommendationScroll),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
    }
    const opener = target.closest('[data-mw-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.mwOpen);
      if (dialog?.matches('.mw-catalog-dialog')) focusOrigins.set(dialog, opener);
    }
    if (target.matches('.mw-catalog-dialog')) {
      const box = target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) target.close();
    }
    if (target.closest('[data-mw-reset]')) {
      const form = target.closest('form');
      form?.querySelectorAll('input[type=checkbox]').forEach(input => {input.checked = false;});
      form?.querySelectorAll('input[type=number]').forEach(input => {input.value = ''; input.setCustomValidity('');});
    }
  });
  document.addEventListener('close', (event) => {
    const dialog = event.target;
    if (!dialog.matches?.('.mw-catalog-dialog')) return;
    dialog.querySelector('form')?.reset();
    dialog.querySelectorAll('input[type=number]').forEach(input => input.setCustomValidity(''));
    focusOrigins.get(dialog)?.focus({preventScroll:true});
  }, true);
  document.addEventListener('input', (event) => {
    const range = event.target.closest?.('[data-mw-price-range]');
    if (!range) return;
    const [min, max] = range.querySelectorAll('input');
    max.setCustomValidity(min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value) ? range.dataset.error : '');
  });
  document.addEventListener('formdata', (event) => {
    if (!event.target.matches('.mw-catalog-form')) return;
    for (const [key, value] of [...event.formData.entries()]) if (key.startsWith('filter.') && value === '') event.formData.delete(key);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) event.formData.set('preview_theme_id', preview);
  });
  document.addEventListener('submit', (event) => {
    if (event.target.matches('.mw-catalog-form')) event.target.setAttribute('aria-busy','true');
  });
  let latestCart;
  let quantityBusy = false;
  const matchingLine = (cart, variant) => (cart.items || []).filter(item => String(item.variant_id) === variant && !item.selling_plan_allocation && !Object.values(item.properties || {}).some(value => value !== '' && value != null));
  const renderQuantities = cart => {
    document.querySelectorAll('[data-mw-stepper]').forEach(stepper => {
      const lines = matchingLine(cart, stepper.dataset.variantId);
      const line = lines.length === 1 ? lines[0] : null;
      const quantity = line?.quantity || 0;
      stepper.hidden = quantity === 0;
      stepper.closest('quick-add-component')?.toggleAttribute('data-mw-has-quantity', quantity > 0);
      stepper.querySelector('[data-mw-quantity-value]').textContent = String(quantity);
      stepper.querySelectorAll('button').forEach(button => {
        const max = Number(stepper.dataset.max) || Infinity;
        button.disabled = quantityBusy || (button.dataset.mwQuantityChange === '1' && quantity + Number(stepper.dataset.step) > max);
      });
      stepper.setAttribute('aria-busy', String(quantityBusy));
    });
  };
  const renderCart = cart => {
    if (!cart || !Number.isFinite(cart.item_count)) return;
    latestCart = cart;
    renderQuantities(cart);
    document.querySelectorAll('[data-mw-cart-count]').forEach(node => {node.textContent = cart.item_count > 99 ? '99+' : String(cart.item_count);});
    document.querySelectorAll('[data-mw-cart-summary]').forEach(bar => {
      bar.hidden = cart.item_count === 0;
      const currency = cart.currency || bar.dataset.currency;
      try {bar.querySelector('[data-mw-cart-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(cart.total_price / 100);} catch {}
    });
  };
  let scheduled = 0;
  let requestVersion = 0;
  const refreshCart = () => {
    clearTimeout(scheduled);
    scheduled = setTimeout(async () => {
      const version = ++requestVersion;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {headers:{Accept:'application/json'},cache:'no-store'});
        if (!response.ok) return;
        const cart = await response.json();
        if (version === requestVersion) renderCart(cart);
      } catch {}
    }, 80);
  };
  let CartEvent;
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-mw-quantity-change]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (quantityBusy || !CartEvent) return;
    const stepper = button.closest('[data-mw-stepper]');
    const errorNode = stepper.parentElement.querySelector('[data-mw-quantity-error]');
    errorNode.hidden = true;
    quantityBusy = true;
    if (latestCart) renderQuantities(latestCart);
    let deferred;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const currentResponse = await fetch(`${root}cart.js`, {headers:{Accept:'application/json'},cache:'no-store'});
      if (!currentResponse.ok) throw new Error(stepper.dataset.error);
      const current = await currentResponse.json();
      const lines = matchingLine(current, stepper.dataset.variantId);
      if (lines.length !== 1) {renderCart(current); return;}
      const line = lines[0];
      const min = Number(stepper.dataset.min) || 1;
      const increment = Number(stepper.dataset.step) || 1;
      const next = line.quantity + Number(button.dataset.mwQuantityChange) * increment;
      const quantity = next < min ? 0 : next;
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(node => node.dataset.sectionId))].slice(0,5);
      deferred = CartEvent.createPromise();
      deferred.promise.catch(() => {});
      button.dispatchEvent(new CartEvent({action:quantity ? 'update' : 'remove',context:'cart',lines:[{id:line.key,quantity}],promise:deferred.promise}));
      const response = await fetch(`${root}cart/change.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:line.key,quantity,sections,sections_url:location.pathname})});
      const updated = await response.json();
      if (!response.ok || updated.errors || updated.status) throw new Error(typeof updated.description === 'string' ? updated.description : stepper.dataset.error);
      ++requestVersion;
      renderCart(updated);
      deferred.resolve({cart:CartEvent.createCartFromAjaxResponse(updated),detail:{sections:updated.sections,items:updated.items,itemCount:updated.item_count,source:'mawjood-card-quantity',didError:false}});
      if (quantity === 0) stepper.closest('quick-add-component')?.querySelector('.quick-add__button--add')?.focus({preventScroll:true});
    } catch (error) {
      errorNode.textContent = error.message || stepper.dataset.error;
      errorNode.hidden = false;
      deferred?.reject(error);
      refreshCart();
    } finally {
      quantityBusy = false;
      if (latestCart) renderQuantities(latestCart);
    }
  });
  import('@shopify/events').then(({StandardEvents,CartLinesUpdateEvent}) => {
    CartEvent = CartLinesUpdateEvent;
    document.addEventListener(StandardEvents.cartLinesUpdate, event => event.promise?.then(refreshCart).catch(() => {}));
  }).catch(() => {});
  window.addEventListener('pageshow', event => {if (event.persisted) refreshCart();});
  document.addEventListener('shopify:section:load', refreshCart);
  let cardRefresh;
  new MutationObserver(records => {
    if (!records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('product-card') || node.querySelector?.('[data-mw-stepper]'))))) return;
    clearTimeout(cardRefresh);
    cardRefresh = setTimeout(() => {if (latestCart) renderQuantities(latestCart);}, 0);
  }).observe(document.body,{childList:true,subtree:true});
  refreshCart();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mawjood-design-system"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.mawjoodStorefrontInitialized) return;
  window.mawjoodStorefrontInitialized = true;
  const openers = new WeakMap();
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const opener = target.closest('[data-mw-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.mwOpen);
      if (dialog instanceof HTMLDialogElement) { event.preventDefault(); openers.set(dialog, opener); dialog.showModal(); }
      return;
    }
    const close = target.closest('[data-mw-close]');
    if (close) close.closest('dialog')?.close();
    const cartLink = target.closest('[data-mw-cart-open]');
    if (cartLink) {
      const cart = document.getElementById('cart-drawer');
      if (cart && typeof cart.open === 'function') { event.preventDefault(); cart.open(); }
    }
    const searchLink = target.closest('[data-mw-search-open]');
    if (searchLink) {
      const search = document.getElementById('search-modal');
      if (search && typeof search.showDialog === 'function') { event.preventDefault(); search.showDialog(); }
    }
    if (target.matches('.mw-menu-dialog')) {
      const rect = target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) target.close();
    }
  });
  document.addEventListener('close', (event) => {
    if (event.target.matches?.('.mw-menu-dialog')) openers.get(event.target)?.focus();
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.mw-filter-details[open]').forEach((node) => {node.open = false; node.querySelector('summary')?.focus();});
  });
  const drawCount = (count) => {
    if (!Number.isFinite(count)) return;
    document.querySelectorAll('[data-mw-cart-count]').forEach((node) => {node.textContent = count > 99 ? '99+' : String(count);});
  };
  import('@shopify/events').then(({ StandardEvents }) => {
    document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
      event.promise?.then(({ cart, detail }) => {
        const count = cart?.totalQuantity ?? detail?.itemCount;
        if (typeof count === 'number') drawCount(count);
      }).catch(() => {});
    });
  }).catch(() => {});
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    const root = window.Shopify?.routes?.root || '/';
    fetch(`${root}cart.js`, {headers: {Accept: 'application/json'}}).then((response) => {
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    }).then((cart) => drawCount(cart.item_count)).catch(() => {});
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mawjood-home-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mawjood-home-carousel')) {
  customElements.define('mawjood-home-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-home-track]');
      this.controls = this.querySelector('[data-home-controls]');
      if (!this.track || !this.controls) return;
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous = this.querySelector('[data-home-prev]');
      this.next = this.querySelector('[data-home-next]');
      this.position = this.querySelector('[data-home-position]');
      this.update = () => {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const offset = Math.abs(this.track.scrollLeft);
        this.controls.hidden = maximum < 3;
        this.previous.disabled = offset < 3;
        this.next.disabled = offset >= maximum - 3;
        if (this.position) {
          const first = this.track.firstElementChild;
          const step = first?.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
          this.position.textContent = `${Math.min(this.track.children.length, Math.round(offset / (step || 1)) + 1)} / ${this.track.children.length}`;
        }
      };
      this.move = direction => {
        const child = this.track.firstElementChild;
        if (!child) return;
        const step = child.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({left: step * direction * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', this.update, {...options, passive:true});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
      }, options);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mawjood-navigation-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mawjood-sticky-header')) {
  customElements.define('mawjood-sticky-header', class extends HTMLElement {
    connectedCallback() {
      const measure = () => document.documentElement.style.setProperty('--mw-sticky-header-height', `${Math.ceil(this.getBoundingClientRect().height)}px`);
      this.observer = new ResizeObserver(measure);
      this.observer.observe(this);
      measure();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mawjood-product-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mawjood-product-description')) {
  customElements.define('mawjood-product-description', class extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('.mw-pdp-description');
      this.button = this.querySelector('button');
      if (!this.body || !this.button) return;
      this.onToggle = () => {
        const expanded = this.toggleAttribute('data-expanded');
        this.button.setAttribute('aria-expanded', String(expanded));
        this.button.querySelector('span').textContent = expanded ? this.button.dataset.less : this.button.dataset.more;
        if (!expanded) this.button.scrollIntoView({block:'nearest'});
      };
      this.button.addEventListener('click', this.onToggle);
      this.observer = new ResizeObserver(() => {
        const limit = parseFloat(getComputedStyle(this).getPropertyValue('--mw-description-limit')) || 88;
        const foldable = this.hasAttribute('data-expanded') || this.body.scrollHeight > limit + 8;
        this.toggleAttribute('data-foldable', foldable);
        this.button.hidden = !foldable;
      });
      this.observer.observe(this.body);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onToggle);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
